import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

const Flex = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;

const TextWrap = styled.div`
  margin-left: 10px;
  font-size: 14px;
  line-height: 24px;
  flex: 1;
`;

const Label = styled.span`
  font-weight: bold;
  display: inline;
`;

type ImageProps = IThemeProps<{
  imageUrl: string;
  isDaliUrl: boolean;
}>;
const Image = styled.div<ImageProps>`
  overflow: hidden;
  position: relative;
  width: 40px;
  height: 40px;
  background-image: url(${(props: ImageProps) =>
    `${props.imageUrl}${props.isDaliUrl ? "?width=40&height=40" : ""}`});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export { Flex, Image, Label, TextWrap };
